import React, { useState } from 'react';
import { useNavigate } from 'react-router';

import styled from '@emotion/styled';

import { ClickOutDropDown } from '../../../components/DropDown/ClickOutDropDown';
import { ChevronDown } from '../../../components/Icons/ChevronDown';
import ListIcon from '../../../components/Icons/ListIcon';
import UnassignedVehicleIcon from '../../../components/Icons/UnassignedVehicleIcon';
import UserProfileIcon from '../../../components/Icons/UserProfileIcon';
import { Modal } from '../../../components/Modal/Modal';
import AssignVehicleModal from '../../../components/Modal/ModalActions/AssignVehicleModal/AssignVehicleModal';
import ListVehicleModal from '../../../components/Modal/ModalActions/ListVehicleModal/ListVehicleModal';
import { VEHICLE_LIST } from '../../../routes/routeConstants';

const ManageDriver = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [modalName, setModalName] = useState<
    '' | 'listVehicle' | 'viewVehicleList' | 'assignVehicle'
  >('');
  return (
    <Container>
      <ClickOutDropDown
        posRight='0px'
        maxHeight='170px'
        label={
          <DropDownLabel>
            Manage Driver <ChevronDown />
          </DropDownLabel>
        }
      >
        <DropDownContent>
          <DivCell
            onClick={() => {
              setModalName('listVehicle');
              setShowModal(true);
            }}
          >
            <UserProfileIcon /> List Vehicles
          </DivCell>
          <DivCell onClick={() => navigate(`/${VEHICLE_LIST}`)}>
            <ListIcon /> View Vehicle List
          </DivCell>
          <DivCell
            onClick={() => {
              setModalName('assignVehicle');
              setShowModal(true);
            }}
          >
            <UnassignedVehicleIcon /> Assign Vehicles to Drivers
          </DivCell>
        </DropDownContent>
      </ClickOutDropDown>

      <Modal
        showModal={showModal && modalName !== ''}
        setShowModal={setShowModal}
      >
        {modalName === 'listVehicle' && <ListVehicleModal />}
        {modalName === 'assignVehicle' && <AssignVehicleModal />}
      </Modal>
    </Container>
  );
};

export default ManageDriver;

const Container = styled.div``;

const DropDownLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-weight: 600;
  font-size: 14px;
  color: #5b91f5;
  border: 1px solid #5b91f5;
  padding: 10px 16px;
  border-radius: 8px;
  cursor: pointer;
`;

const DropDownContent = styled.div`
  display: flex;
  flex-direction: column;

  background-color: white;
  padding: 4px 0;
  gap: 4px;

  width: 283px;
`;

const DivCell = styled.div`
  padding: 13px 16px;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 16px;
  font-weight: 500;
  color: #6b7280;
  cursor: pointer;

  &:hover {
    background-color: #f9fafb;
  }
`;
